module.exports = __webpack_public_path__ + "assets/img/item02.19df59a9.png";